export const validation = {
  maxTitleChar: 120,
  musicUrls: {
    min: 1,
    max: 12
  }
}
